export default __webpack_public_path__ + "static/media/banner2.203fc589.jpg";